import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  icon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.2, 0, 0),
  },
  text: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    letterSpacing: '0.25px',
  },
  account: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: '16px',
    textAlign: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: theme.spacing(1.75),
  },
  currency: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
    textAlign: 'center',
  },
  avatar: {
    '&.MuiAvatar-root': {
      display: 'flex',
      width: theme.spacing(3),
      height: theme.spacing(3),
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1.25),
      textAlign: 'center',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: '0.5px',
      border: '1px solid transparent',
      color: theme.palette.labraText.tertiary,
      borderRadius: theme.spacing(6.5),
      background: `linear-gradient(0deg, ${theme.palette.avatarColors.blue} 0%, ${theme.palette.avatarColors.blue} 100%)`,
    },
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
  },
}))
